<template>
	<div>
		<div class="border-b border-gray-200">
			<nav
				class="-mb-px flex space-x-8"
				aria-label="Tabs"
			>
				<a
					v-for="tab in tabs"
					:key="tab.name"
					href="#"
					:class="[
						current == tab.id
							? 'won-border-color-green won-blue'
							: 'won-settings-gray border-transparent hover:border-gray-300 hover:text-gray-500',
						small ? 'py-1! text-sm!' : '',
						'border-b-4 px-1 py-2 text-base font-medium whitespace-nowrap',
					]"
					:aria-current="current == tab.id ? 'page' : undefined"
					@click="() => emit('changed', tab.id)"
				>
					{{ tab.name }}
				</a>
			</nav>
		</div>
	</div>
</template>

<script setup>
const emit = defineEmits(['changed']);
defineProps({
	tabs: {
		type: Array,
		required: true,
	},
	current: {
		type: String,
		required: true,
	},
	small: {
		type: Boolean,
		default: false,
	},
});
</script>
